<template lang="pug">
  .exclusion-company-name
    .wrap
      .main
        .main-inner
          .main-header
            h2 登録企業の管理
            p
              | 求人検索時に検索条件に含めたい企業を登録することができます。<br />
              | 登録することのできる社数上限は1,000社となっておりますが、社数が増えれば増えるほど、検索に時間がかかってしまうようになるためご留意ください。<br />
              | 1行1社ずつ企業名を入力し、下部のボタンでON/OFFを設定した上で、「更新する」ボタンを押すと、登録が完了します。<br />
              | ※部分一致で検索を行うため、「〇〇」を登録すると、事業所名に「〇〇株式会社、〇〇株式会社 東京支店、…」を含む求人が検索結果に含まれます。

          .box-search
            form(@submit.prevent="updateInclusionCompanyName")
              p.name-count-area
                | {{ Number(this.getCompanyNameCount()).toLocaleString() }} / {{ Number(companyNameMaxCount).toLocaleString() }}社
              p.name-count-over(v-if="companyNameCount > companyNameMaxCount")
                | 登録することのできる社数上限は1,000社です。
              .textarea-box
                textarea(v-model="companyName")
              .flex-box
                .flex-item.only-pc
                  | 上記の企業を検索対象に含める:
                .flex-item
                  .switch-area
                    input(type="checkbox" id="chk-enable" v-model="enable")
                    label(for="chk-enable")
                      span
                    #sw-img
                .flex-item
                  p.buttons
                    button.button-main.only-pc(type="submit" value="コメントを更新する" v-bind:disabled="companyNameCount > companyNameMaxCount")
                      | 更新する
                    button.button-main.only-sp(type="submit" value="コメントを更新する" v-bind:disabled="companyNameCount > companyNameMaxCount")
                      | 更新


</template>

<script>
  import { mapState } from 'vuex'
  import { HumanInfoMessages } from '../constants'
  import inclusionCompanyName from '../store/modules/inclusionCompanyName'
  import mapGetSet from '../libs/map-get-set'

  export default {
    async asyncData ({ store }) {
      await store.dispatch('inclusionCompanyName/fetch')
    },
    data () {
      return {
        companyNameMaxCount: 1000,
        companyNameCount: 0,
      }
    },
    computed: {
      ...mapState({
        companyName: state => state.inclusionCompanyName.companyName,
        enable: state => state.inclusionCompanyName.enable,
      }),
      ...mapGetSet({
        _this: this,
        get: ($vm, $s, k) => $s.state.inclusionCompanyName[k],
        set: ($vm, $s, k, v) => $s.commit(`inclusionCompanyName/${k}`, v),
        keys: Object.keys(inclusionCompanyName.state),
      }),
    },

    methods: {
      async updateInclusionCompanyName () {
        this.$store.commit('common/lockGlobal')
        const companyName = this.companyName
        const enable = this.enable

        if (this.companyNameCount > this.companyNameMaxCount) {
          // eslint-disable-next-line no-alert
          return alert('登録することのできる社数上限は1,000社です。')
        }

        try {
          this.$store.dispatch('inclusionCompanyName/update', { companyName, enable })
          this.$store.dispatch('common/pushToastInfo', { info: HumanInfoMessages.SAVE_INCLUSION_COMPANY_NAME })
        } catch (e) {
          this.$store.dispatch('common/pushToastError', { error: e })
        } finally {
          this.$store.commit('common/unlockGlobal')
        }
      },
      getCompanyNameCount () {
        const companyNameArray = this.companyName.split('\n')
        const count = companyNameArray.filter(v => v !== '').length
        this.companyNameCount = count

        return count
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/InclusionCompanyName.vue